import React from "react";

export default function Map () {
    return(
        <div className="flex place-items-center w-[80%] h-auto -mb-40">
            <iframe title="Map" height="250" width="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5553.704792592798!2d-67.96570977763626!3d10.175590040688423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e8067a28672dc13%3A0x79e1c439661effdc!2sQuimica%20Nouma!5e0!3m2!1ses!2sve!4v1719579717632!5m2!1ses!2sve" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    )
}